import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { LoggerProvider } from '@shared';
import { CaseFormRepository } from '../../../infrastructure/repositories/case-form.repository';
import { CaseFormState } from '../../states/case-form.state';
import { CreateCaseFormDraftVersionQuery } from './create-case-form-draft-version.query';

/**
 * Create Case Form Draft Version Use Case
 * Creates a new draft version for a case form
 *
 * POST /api/v1/cases/forms/{formId}/versions
 */
@Injectable({ providedIn: 'root' })
export class CreateCaseFormDraftVersionUseCase {
  private readonly _repository = inject(CaseFormRepository);
  private readonly _state = inject(CaseFormState);
  private readonly _logger = inject(LoggerProvider).createScoped('CreateCaseFormDraftVersionUseCase');

  public execute(query: CreateCaseFormDraftVersionQuery): Observable<{ versionId: string }> {
    this._state.setLoadingCaseForm(true);
    this._state.clearErrorCaseForm();

    return this._repository.createCaseFormDraftVersion(query.formId).pipe(
      tap((result) => {
        this._logger.info('Created draft version', { versionId: result.versionId, formId: query.formId });
      }),
      catchError((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          `Failed to create draft version for form ${query.formId}`;
        this._state.setErrorCaseForm(errorMessage);
        return throwError(() => error);
      }),
      finalize(() => this._state.setLoadingCaseForm(false))
    );
  }
}
